// css =>
import Styled from './spinner.module.css';

// context =>
import { useTheme } from '../../context/theme-context';

const SpinnerBar = () => {
    const { theme, toggleTheme } = useTheme();

    return (
        <div
            className={Styled.spinner_container}
            style={{
                backgroundColor: theme === "day" ? "#E5E5E5" : ""
            }}
        >
            <div className={Styled.spinner}>
                <div className={Styled.spinner_circle}></div>
                <div className={Styled.spinner_circle}></div>
                <div className={Styled.spinner_circle}></div>
            </div>
        </div>
    );
};

export default SpinnerBar;
